import { IconButton, Tooltip } from '@mui/material';
import { LuPencil } from 'react-icons/lu';
import type { MarketPrice } from '../../schema';

export interface MarketPriceRowActions {
  onEdit: (row: MarketPrice) => void;
}

interface Props extends MarketPriceRowActions {
  row: MarketPrice;
}

export function RowActions({ row, onEdit }: Props) {
  const label = `Edit prices for ${row.cropName} at ${row.apmcName} on ${row.priceDate}`;
  return (
    // h-full so flex centering has the row's full height to work against —
    // without it the wrapper collapses to the icon's height and the icon
    // ends up top-aligned in the row.
    <div className="flex h-full items-center justify-center">
      <Tooltip title="Edit prices">
        <IconButton
          size="small"
          onClick={() => onEdit(row)}
          aria-label={label}
          sx={{
            color: 'text.secondary',
            '&:hover': { color: 'primary.main', bgcolor: 'action.hover' },
          }}
        >
          <LuPencil size={16} />
        </IconButton>
      </Tooltip>
    </div>
  );
}
